
export const SalesOrdersLang = {
    TituloReporte: {
        es: 'ORDEN DE VENTA',
        en: 'SALES ORDER',
    },
    fecha: {
        es: 'Fecha',
        en: 'Date',
    },
    direccion: {
        es: 'Dirección: ',
        en: 'Address: ',
    },
    customerOrder: {
        es: 'Orden de Cliente',
        en: 'Customer Order',
    },
    agente: {
        es: 'Agente de Ventas',
        en: 'Sales Agent',
    },
    cliente: {
        es: 'Cliente',
        en: 'Customer',
    },
    terminoEnvio: {
        es: 'Término de Envío',
        en: 'Shipping Term',
    },
    terminoVenta: {
        es: 'Término de Venta',
        en: 'Term of Sale',
    },
    estado: {
        es: 'Estado',
        en: 'Status',
    },
    yarn: {
        es: 'HILO',
        en: 'YARN',
    },
    fechaExportancion: {
        es: 'EXPORTACION',
        en: 'EXPORT',
    },
    Cantidad: {
        es: 'CANTIDAD',
        en: 'QUANTITY',
    },
    PrecioL: {
        es: 'PRECIO L',
        en: 'PRICE L',
    },
    SubTotalL: {
        es: 'SUBTOTAL L',
        en: 'SUBTOTAL L',
    },
    comentario: {
        es: 'Comentario',
        en: 'Comment',
    },
    fechaImpresion: {
        es: 'Fecha de Impresión: ',
        en: 'Print Date: ',
    },
}